import apiClient, {errorHandling, errorConsole} from '../apiClient';

const usuariosServices = {
  obtenerUsuarios: async (sortBy='', q='') => {
    try {
      const response = await apiClient.get(`/usuarios?query=${q}&sortBy=${sortBy}`);

      return response.data;      
    } catch (error) {
      throw error;
    }
  },
  obtenerUsuarioPorId: async (id) => {
    try {
      const response = await apiClient.get(`/usuarios/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  actualizarUsuario: async (id, params) => {
    try {
      params.usuario.rol = 'Roles::' + params.usuario.rol
      const response = await apiClient.put(`/usuarios/${id}`, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  nuevoUsuario: async () => {
    try {
      const response = await apiClient.post(`/usuarios/new`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearUsuario: async (params) => {
    try {
      params.usuario.rol = 'Roles::' + params.usuario.rol
      const response = await apiClient.post(`/usuarios/`, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  cambiarClave: async (params) => {
    try {
      const response = await apiClient.put(`/usuarios/cambiarClave`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  olvidoClave: async (email) => {
    try {
      const response = await apiClient.post(`/passwords/forgot`, {email: email});

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  recuperoClave: async (params) => {
    try {
      const response = await apiClient.post(`/passwords/reset`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  obtenerRoles: async () => {
    try {
      const response = await apiClient.get(`/usuarios/obtenerRoles`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  obtenerProvincias: async () => {
    try {
      const response = await apiClient.get(`/usuarios/obtenerProvincias`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarUsuario: async (id) => {
    try {
      const response = await apiClient.delete(`/usuarios/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  activarUsuario: async (token) => {
    try {
      const response = await apiClient.post(`/passwords/activarUsuario`, token);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default usuariosServices;
